import { Pipe, PipeTransform, inject } from '@angular/core';

import { IntlService } from './intl.service';

/**
 * @whatItDoes Transforms a currency code into a currency symbol string
 *
 * @howToUse
 * ```
 * {{ 'USD' | vnCurrencySymbol }}
 * ```
 *
 */
@Pipe({
    standalone: true,
    name: 'vnCurrencySymbol',
})
export class CurrencySymbolPipe implements PipeTransform {
    private readonly intlService = inject(IntlService);

    transform(code: string): string {
        return this.intlService.formatCurrencySymbol(code);
    }
}
